export const POS_CFD_HWAGENT = 'POS_CFD_HWAGENT'
export const CLIENT_STORE = 'CFD_CLIENT'
export const HWAGENT_STORE = 'HWAGENT_STORE'
export const COOKIES_TOKEN = 'token'
